import React, { useContext, useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setScrollDirection } from '../../../common/redux/features/siteConfig/actions';
import { throttle } from 'lodash';
import debounce from 'lodash/debounce';
import { StoreContext } from '../../appContext/StoreProvider';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { scrollToActiveElementOnMount } from '../../../utils/locationUtils';
import { NAV_TYPES } from '../../LoggerFactory/BiAnalyticsLogger/events/consts';
import SectionIntersectionDetection from '../SectionIntersectionDetection';
import { ApiSectionView } from './ApiSectionView';
import { getNodeByPath } from '../../../Store/Utils/treeUtils';
import style from './LibraryView.scss';

export default function LibraryView({ withNotificationBar, customPath }) {
  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();

  const { store } = useContext(StoreContext);

  const [lastScrollPos, setLastScrollPos] = useState(0);
  const [parentNode, setParentNode] = useState(
    getNodeByPath(store.getFullTree(), customPath || match.path),
  );

  const handleScrollThrottled = useCallback(throttle(handleScroll, 100), [
    lastScrollPos,
  ]);

  const onIntersectionHandlerDebounce = useCallback(
    debounce(onIntersectionHandler, 30, { maxWait: 100 }),
    [location.pathname],
  );

  useEffect(() => {
    if (parentNode) {
      scrollToActiveElementOnMount(location);
    }
  }, []);

  return (
    <>
      {!!parentNode && (
        <div onScroll={handleScrollThrottled} className={style.contentWrapper}>
          <SectionIntersectionDetection
            dataHook={`main-apis-view-${parentNode.data.urlFormat}`}
            onIntersection={onIntersectionHandlerDebounce}
            withNotificationBar={withNotificationBar}
          >
            {({ sectionWrapper }) => {
              return (
                <>
                  <span id="top" className={style.top} />
                  <ApiSectionView
                    id={parentNode.data.urlFormat}
                    depth={0}
                    node={parentNode}
                    key={parentNode.data.urlFormat}
                    sectionWrapper={sectionWrapper}
                  />
                </>
              );
            }}
          </SectionIntersectionDetection>
        </div>
      )}
    </>
  );

  function handleScroll(event) {
    if (window && window.isScrollFromLibraryView) {
      window.isScrollFromLibraryView = false;
      return;
    }

    const target = event && event.target;
    event.persist();

    if (target) {
      if (lastScrollPos > target.scrollTop) {
        dispatch(setScrollDirection('top'));
      } else if (lastScrollPos < target.scrollTop) {
        dispatch(setScrollDirection('bottom'));
      }
      setLastScrollPos(target.scrollTop);
    }
  }

  function onIntersectionHandler(entry) {
    const [sectionName] = entry.target.id.split('#');
    const focusLocation = `/${sectionName}`.replace(/^\/+/, '/');
    store.publishToFocusLocation(focusLocation);
    if (location.pathname !== focusLocation) {
      history.push({
        pathname: focusLocation,
        search: location.search,
        hash: location.hash,
        state: { navType: NAV_TYPES.SCROLL },
      });
    }
  }
}
